function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { createBreakpointMapTextSize, stopPropagationAndCallFunction } from '../../../helpers/react-helpers';
import Icon from '../../../icon';
import { ErrorIcon, InfoIconUnfocusedInputButton, StyledMaskedInput, StyledUnmaskedInput, TriggerTooltipWrapper } from './style';
export var Input = props => {
  var {
    value,
    isFocused,
    interactableReadOnly
  } = props;

  var {
    showError,
    textSize,
    forwardRef,
    mask,
    name,
    onInfoIconClick
  } = props,
      inputProps = _objectWithoutProperties(props, ["showError", "textSize", "forwardRef", "mask", "name", "onInfoIconClick"]);

  var inputRefFunction = input => input && isFocused && input.focus();

  var inputRef = forwardRef ? forwardRef : inputRefFunction;

  if (interactableReadOnly) {
    inputProps.readOnly = true;
  }

  var textSizeMap = createBreakpointMapTextSize(textSize);

  if (mask) {
    return /*#__PURE__*/React.createElement(StyledMaskedInput, _extends({}, inputProps, {
      name: name,
      mask: value ? mask : '',
      textSizeMap: textSizeMap,
      showError: showError,
      inputRef: inputRef
    }));
  }

  return /*#__PURE__*/React.createElement(StyledUnmaskedInput, _extends({}, inputProps, {
    id: name,
    name: name,
    textSizeMap: textSizeMap,
    showError: showError,
    ref: inputRef
  }));
};

var ErrorDisplay = props => {
  var {
    showError
  } = props;
  var hide = !showError;
  return /*#__PURE__*/React.createElement(ErrorIcon, {
    hide: hide,
    icon: 'WrongInput'
  });
};

export default function InputField(props) {
  var {
    interactableReadOnly,
    disableErrorXIcon,
    showError,
    readOnly,
    value,
    forwardRef,
    onInfoIconClick,
    isFocused
  } = props;
  var inputValue = !value && readOnly ? '—' : value;
  var hideInfoIconInputButton = !onInfoIconClick || inputValue !== '' || !!isFocused;
  var showErrorConsideringInfoIcon = showError && hideInfoIconInputButton && !disableErrorXIcon;

  var {
    enableTriggerTooltip,
    tooltipContent,
    dangerouslySetOverlayInnerHTML,
    enableInfoIconTooltip
  } = props,
      inputProps = _objectWithoutProperties(props, ["enableTriggerTooltip", "tooltipContent", "dangerouslySetOverlayInnerHTML", "enableInfoIconTooltip"]);

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
    forwardRef: forwardRef,
    value: inputValue
  })), !enableInfoIconTooltip && onInfoIconClick && /*#__PURE__*/React.createElement(InfoIconUnfocusedInputButton, {
    hide: hideInfoIconInputButton,
    onClick: stopPropagationAndCallFunction(onInfoIconClick),
    icon: 'Info',
    size: 16
  }), enableInfoIconTooltip && tooltipContent && /*#__PURE__*/React.createElement(TriggerTooltipWrapper, {
    placement: 'topRight',
    overlay: tooltipContent,
    dangerouslySetOverlayInnerHTML: dangerouslySetOverlayInnerHTML
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(InfoIconUnfocusedInputButton, {
    hide: inputValue !== '' || !!isFocused,
    icon: 'Info',
    size: 16,
    isTooltip: true
  }))), enableTriggerTooltip && /*#__PURE__*/React.createElement(TriggerTooltipWrapper, {
    placement: 'topRight',
    overlay: tooltipContent,
    dangerouslySetOverlayInnerHTML: dangerouslySetOverlayInnerHTML
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    icon: 'Info',
    size: 16
  }))), !interactableReadOnly && /*#__PURE__*/React.createElement(ErrorDisplay, {
    showError: showErrorConsideringInfoIcon
  }));
}